import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, Crown, Medal } from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const MONTH_NAMES_NO = [
  'januar', 'februar', 'mars', 'april', 'mai', 'juni',
  'juli', 'august', 'september', 'oktober', 'november', 'desember',
];

const MonthlyChampionCard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API_BASE}/api/merkeskyting/monthly-champion`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (!data || !data.champion) return null; // Skjul hvis ingen kandidater

  const [y, m] = (data.month || '').split('-');
  const monthLabel = m ? `${MONTH_NAMES_NO[parseInt(m,10) - 1]} ${y}` : '';

  return (
    <div className="bg-gradient-to-br from-yellow-500/20 via-amber-600/10 to-orange-500/20 border border-yellow-500/40 rounded-2xl p-5 shadow-lg" data-testid="monthly-champion-card">
      <div className="flex items-start gap-3 mb-3">
        <div className="p-2 bg-yellow-500/30 rounded-xl">
          <Crown className="w-6 h-6 text-yellow-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-yellow-300 text-xs font-bold uppercase tracking-wider">Månedens Merkeskytter</p>
          <p className="text-white text-lg font-black capitalize">{monthLabel}</p>
        </div>
      </div>

      {/* Champion */}
      <div className="bg-black/30 rounded-xl p-4 mb-3 flex items-center gap-4">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center text-2xl font-black text-gray-900 flex-shrink-0">
          1
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white text-xl font-black truncate">{data.champion.name}</p>
          <p className="text-yellow-300 text-sm font-bold">{data.champion.count} kvalifiserende serier</p>
        </div>
        <Trophy className="w-8 h-8 text-yellow-400 flex-shrink-0" />
      </div>

      {/* Runners-up */}
      {data.runners_up?.length > 0 && (
        <div className="space-y-1">
          {data.runners_up.map((r, i) => (
            <div key={r.member_id} className="flex items-center gap-3 p-2 rounded-lg bg-black/20">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                i === 0 ? 'bg-gray-400 text-gray-900' : i === 1 ? 'bg-amber-700 text-white' : 'bg-gray-700 text-gray-300'
              }`}>
                {i + 2}
              </div>
              <span className="flex-1 text-white text-sm font-medium truncate">{r.name}</span>
              <span className="text-yellow-300 text-sm font-bold">{r.count}</span>
            </div>
          ))}
        </div>
      )}

      <p className="text-gray-400 text-xs mt-3">
        Basert på antall registrerte merkeskyting-serier i inneværende måned.
      </p>
    </div>
  );
};

export default MonthlyChampionCard;
